import {
  removeSpecialCharacters,
  removeNonNumericCharacters,
  addThousandsSeparators,
} from "./utils";

const alphanumericAndHyphenRegex = /^[A-Za-z0-9-]*$/;

export const required = (value) => {
  return value || typeof value === "number" ? undefined : "This field is required";
};

export const number = (value) => {
  return value && isNaN(Number(removeSpecialCharacters(value))) ? "Must be a number" : undefined;
};

export const alphanumericAndHyphen = (value) => {
  return value && alphanumericAndHyphenRegex.test(value)
    ? undefined
    : "Must be only numbers, letters, and hyphens";
};

export const checkHyphens = (string) => {
  if (string[0] === "-" || string[string.length - 1] === "-" || string.indexOf("--") !== -1) {
    return "Must only be letters, numbers, and hyphens";
  }
  return undefined;
};

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = (min) => (value) =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const fieldLength = (len) => (value) =>
  value && removeSpecialCharacters(value).length != len
    ? `Must be ${len} characters exactly`
    : undefined;

export const emailCheck = (value) => {
  // trim trailing spaces before validating email
  return value &&
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value.trim()
    )
    ? "Invalid email address"
    : undefined;
};

export const emailConfirmation = (value, values) => {
  return value && value !== values["email"] ? "Email addresses do not match" : undefined;
};

export const emailConfirmationCoBorrower = (value, values) => {
  return value && value !== values["CoBorrowerEmail"] ? "Email addresses do not match" : undefined;
};

export const zipCodeCheck = (value) => {
  return value && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value) ? "Invalid zip code" : undefined;
};

export const valueLessThan = (minValue) => (value) => {
  return value && removeNonNumericCharacters(value) >= minValue
    ? `Value must be less than ${minValue}`
    : undefined;
};

export const valueGreaterThan = (minValue) => (value) => {
  return value && removeNonNumericCharacters(value) <= minValue
    ? `Value must be greater than ${minValue}`
    : undefined;
};

export const maxPaymentAmount = (maxValue) => (value) => {
  if (maxValue && value) {
    return parseFloat(removeSpecialCharacters(value)) <= maxValue
      ? undefined
      : `Maximum amount allowed is $${addThousandsSeparators(maxValue)}.`;
  }
};

// Matching function for account numbers
export const accountNbrMatch = (valueToMatch) => (value) => {
  if (valueToMatch) {
    return value === valueToMatch.values.AccountNumber
      ? undefined
      : "Your account numbers do not match.";
  }
};

// This is the proper implementation for a validator that requires other form values
// Use this one for all future implementations
export const accountNumberMatch = (value, values) => {
  return value && value === values["AccountNumber"]
    ? undefined
    : "Your account numbers do not match";
};

// Have to export them this way or the form library dies
export const valueGreaterThanZero = valueGreaterThan(0);
export const fieldLength3 = fieldLength(3);
export const fieldLength4 = fieldLength(4);
export const fieldLength5 = fieldLength(5);
export const fieldLength9 = fieldLength(9);
export const fieldLength16 = fieldLength(16);
export const maxLength17 = maxLength(17);



// WEBPACK FOOTER //
// ./src/utils/formValidators.js